export default __webpack_public_path__ + "static/media/ic_reset_gray.53b18806.svg";